export default "__VITE_ASSET__aba0e52b__"